import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "fw-bold mb-1" };
const _hoisted_2 = { class: "mb-3 text-secondary" };
const _hoisted_3 = {
    key: 0,
    class: "alert alert-danger mb-3",
    role: "alert"
};
const _hoisted_4 = { class: "tab-content rounded bg-white p-3 mb-4" };
const _hoisted_5 = {
    class: "tab-pane fade show active",
    id: "details-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "details-tab",
    tabindex: "0"
};
const _hoisted_6 = { class: "row mb-4" };
const _hoisted_7 = { class: "col-lg-6 col-12" };
const _hoisted_8 = { class: "form-check mb-3" };
const _hoisted_9 = { class: "form-check mb-3" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = { class: "input-group mb-3" };
const _hoisted_14 = { class: "form-floating" };
const _hoisted_15 = { class: "form-floating mb-3" };
const _hoisted_16 = ["value"];
const _hoisted_17 = { class: "form-floating mb-3" };
const _hoisted_18 = ["value"];
const _hoisted_19 = { class: "form-floating mb-3" };
const _hoisted_20 = { class: "mb-3" };
const _hoisted_21 = { class: "mb-3" };
const _hoisted_22 = { class: "col-12 col-lg-6" };
const _hoisted_23 = { class: "mb-4" };
const _hoisted_24 = { class: "mb-3" };
const _hoisted_25 = {
    class: "tab-pane fade",
    id: "product-images-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "product-images-tab",
    tabindex: "0"
};
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { MultiSelect, useConfirm } from 'primevue';
import TinyEditor from '@/Components/TinyEditor.vue';
import axios from 'axios';
import ProductImages from '@/Tenant/Components/ProductImages.vue';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        accessoryProduct: Object,
        materials: Object,
        productTypes: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        const editAccessoryProductForm = useForm({
            artNo: props.accessoryProduct?.artNo ?? '',
            name: props.accessoryProduct?.name ?? '',
            nameEn: props.accessoryProduct?.nameEn ?? '',
            description: props.accessoryProduct?.description ?? '',
            descriptionEn: props.accessoryProduct?.descriptionEn ?? '',
            weight: props.accessoryProduct?.weight ?? 0,
            materialUuid: props.accessoryProduct?.materialUuid ?? '',
            productTypeUuid: props.accessoryProduct?.productTypeUuid ?? '',
            cartRecommendation: props.accessoryProduct?.cartRecommendation ?? false,
            deliveryDays: props.accessoryProduct?.deliveryDays ?? null,
            active: props.accessoryProduct?.active ?? false
        });
        const productCategories = ref([]);
        const selectedProductCategories = ref([]);
        onMounted(() => {
            loadAvailableProductCategories();
            selectedProductCategories.value = props.accessoryProduct?.productCategories.map((category) => {
                return category.uuid;
            }) ?? [];
        });
        function loadAvailableProductCategories() {
            axios.post(route('admin.productCategories.load')).then((response) => {
                productCategories.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function updateAccessoryProduct() {
            if (props.accessoryProduct == null) {
                return;
            }
            editAccessoryProductForm.transform((data) => ({
                art_no: data.artNo,
                name: data.name,
                name_en: data.nameEn,
                description: data.description,
                description_en: data.descriptionEn,
                weight: data.weight,
                material_uuid: data.materialUuid,
                product_type_uuid: data.productTypeUuid,
                cart_recommendation: data.cartRecommendation,
                delivery_days: data.deliveryDays,
                active: data.active
            }))
                .submit('put', route('admin.accessoryProducts.update', props.accessoryProduct.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeAccessoryProduct() {
            confirm.require({
                message: 'Soll das Produkt wirklich gelöscht werden?',
                header: 'Produkt löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.accessoryProduct == null) {
                        return;
                    }
                    router.delete(route('admin.accessoryProducts.destroy', props.accessoryProduct.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function updateProductCategories() {
            if (props.accessoryProduct == null) {
                return;
            }
            if (selectedProductCategories.value.length === 0) {
                showErrorMessage('Bitte wählen Sie mindestens eine Produktkategorie aus.');
                return;
            }
            router.post(route('admin.accessoryProducts.productCategories.update', props.accessoryProduct.uuid), {
                'productCategoryUuids': selectedProductCategories.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Flasche" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Zubehör-Produkt: " + _toDisplayString(props.accessoryProduct.name), 1),
                        _createElementVNode("p", _hoisted_2, "Letzte Änderung: " + _toDisplayString(_unref(formatDate)(props.accessoryProduct.updatedAt, true)), 1),
                        (props.accessoryProduct.priceBundle && !props.accessoryProduct.priceBundle.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Produkt ist mit einem inaktiven Preis-Bundle verknüpft. Produkt kann somit nicht verwendet werden."))
                            : _createCommentVNode("", true),
                        _cache[31] || (_cache[31] = _createElementVNode("ul", {
                            class: "nav nav-underline mb-3",
                            role: "tablist"
                        }, [
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link active",
                                    id: "details-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#details-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "details-tab-pane",
                                    "aria-selected": "true"
                                }, "Details")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "product-images-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#product-images-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "product-images-tab-pane",
                                    "aria-selected": "false"
                                }, "Produkt-Bilder")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(updateAccessoryProduct, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "active",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editAccessoryProductForm).active) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editAccessoryProductForm).active]
                                                ]),
                                                _cache[12] || (_cache[12] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "active"
                                                }, "Aktiv (Produkt kann erworben werden)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_9, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "cartRecommendation",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editAccessoryProductForm).cartRecommendation) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editAccessoryProductForm).cartRecommendation]
                                                ]),
                                                _cache[13] || (_cache[13] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "cartRecommendation"
                                                }, "Als Warenkorb-Empfehlung anzeigen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "artNo",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editAccessoryProductForm).artNo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editAccessoryProductForm).artNo]
                                                ]),
                                                _cache[14] || (_cache[14] = _createElementVNode("label", { for: "artNo" }, "Artnr.", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_11, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "name",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editAccessoryProductForm).name) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editAccessoryProductForm).name]
                                                ]),
                                                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "nameEn",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editAccessoryProductForm).nameEn) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editAccessoryProductForm).nameEn]
                                                ]),
                                                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "nameEn" }, "Name (en)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editAccessoryProductForm).weight) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editAccessoryProductForm).weight]
                                                    ]),
                                                    _cache[17] || (_cache[17] = _createElementVNode("label", { for: "weight" }, "Gewicht", -1))
                                                ]),
                                                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "input-group-text" }, "g", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "material",
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editAccessoryProductForm).materialUuid) = $event))
                                                }, [
                                                    _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "Keine Option", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.materials, (material) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: material.uuid
                                                        }, _toDisplayString(material.name), 9, _hoisted_16));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editAccessoryProductForm).materialUuid]
                                                ]),
                                                _cache[20] || (_cache[20] = _createElementVNode("label", { for: "material" }, "Material", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "productType",
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editAccessoryProductForm).productTypeUuid) = $event))
                                                }, [
                                                    _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Keine Option", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productTypes, (productType) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: productType.uuid
                                                        }, _toDisplayString(productType.name), 9, _hoisted_18));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editAccessoryProductForm).productTypeUuid]
                                                ]),
                                                _cache[22] || (_cache[22] = _createElementVNode("label", { for: "productType" }, "Produkttyp", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "deliveryDays",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editAccessoryProductForm).deliveryDays) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editAccessoryProductForm).deliveryDays]
                                                ]),
                                                _cache[23] || (_cache[23] = _createElementVNode("label", { for: "deliveryDays" }, "Lieferzeit in Tagen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                                _cache[24] || (_cache[24] = _createElementVNode("label", {
                                                    for: "description",
                                                    class: "mb-2"
                                                }, "Beschreibung", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "description",
                                                    modelValue: _unref(editAccessoryProductForm).description,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(editAccessoryProductForm).description) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _cache[25] || (_cache[25] = _createElementVNode("label", {
                                                    for: "descriptionEn",
                                                    class: "mb-2"
                                                }, "Beschreibung (en)", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "descriptionEn",
                                                    modelValue: _unref(editAccessoryProductForm).descriptionEn,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(editAccessoryProductForm).descriptionEn) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _cache[26] || (_cache[26] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 32),
                                        (props.accessoryProduct.canRemove)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                                onClick: removeAccessoryProduct
                                            }, [...(_cache[27] || (_cache[27] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-x-circle",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                        _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Produkt löschen", -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Produktkategorien", -1)),
                                            _createElementVNode("div", _hoisted_24, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedProductCategories.value,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedProductCategories).value = $event)),
                                                    options: productCategories.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Produktkategorien wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateProductCategories
                                            }, [...(_cache[28] || (_cache[28] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preise", -1)),
                                    _createVNode(ProductPriceOption, {
                                        accessoryProduct: props.accessoryProduct,
                                        priceBundleUuid: props.accessoryProduct.priceBundleUuid
                                    }, null, 8, ["accessoryProduct", "priceBundleUuid"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _createVNode(ProductImages, {
                                    accessoryProduct: props.accessoryProduct
                                }, null, 8, ["accessoryProduct"])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
